__turbopack_context__.v({
  "animate": "style-module-scss-module__4BtrYG__animate",
  "animate2": "style-module-scss-module__4BtrYG__animate2",
  "wave": "style-module-scss-module__4BtrYG__wave",
  "wave1": "style-module-scss-module__4BtrYG__wave1",
  "wave2": "style-module-scss-module__4BtrYG__wave2",
  "wave3": "style-module-scss-module__4BtrYG__wave3",
});
